module.exports = __webpack_public_path__ + "static/media/ContactCenterIcon.388318be.svg";